import { render, staticRenderFns } from "./company-edit-modal.vue?vue&type=template&id=15b3b400&scoped=true&"
import script from "./company-edit-modal.vue?vue&type=script&lang=ts&"
export * from "./company-edit-modal.vue?vue&type=script&lang=ts&"
import style0 from "./company-edit-modal.vue?vue&type=style&index=0&id=15b3b400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b3b400",
  null
  
)

export default component.exports